module.exports = __webpack_public_path__ + "static/media/wind.9aca261a.svg";